export default function ListIconWrapper(props) {
  return (
    <>
      <div className={`list-icon-wrapper bg-theme-blue rounded-full flex items-center justify-center ${props.className ?? ''}`}>
        {props.children}
      </div>
    </>
  );
}
